import React, { Component, Fragment } from "react";

import { Iconclass } from "../../iconclass/components/Iconclass";
import { facetName } from "../../facet/rendering";

class FilterView extends Component {
  render() {
    const { aFilter } = this.props;
    switch (aFilter.fieldName) {
      case "ICPATH":
        return (
          <Iconclass
            triggerUpdate={this.props.triggerUpdate}
            notation={aFilter.fieldValue}
            inline
            pathrefine
            aFilter={aFilter}
            search={this.props.search}
            shownotation
          />
        );
      case "PERSON":
        return <Fragment> person: {aFilter.fieldValue}</Fragment>;
      case "SPECIES":
        return <Fragment> species: {aFilter.fieldValue}</Fragment>;
      default:
        return (
          facetName(aFilter.fieldName, aFilter.fieldValue) || aFilter.fieldValue
        );
    }
  }
}

export default FilterView;
